module.exports = __webpack_public_path__ + "img/setting.19619fd3.svg";